import React from "react";
import { FormattedMessage } from "react-intl";
import { useOutletContext } from "react-router";
import { PrimaryButton } from "components/Buttons";
import DropDown, { DropDownToggle, DropDownMenu, DropDownItem } from "components/DropDown";
import { TERM_SHEET_PRICING_TYPES } from "constants/index";
import { useLegacyTermSheet } from "hooks";

/**
 * AddLegacyTermSheetButton
 */
const AddLegacyTermSheetButton = () => {
  const { selectedSquad } = useOutletContext();
  const { handleAddTermSheet } = useLegacyTermSheet();

  return (
    <DropDown>
      <DropDownToggle as={PrimaryButton} id="dropdown-basic">
        <FormattedMessage id="TermSheets.LegacyTermSheetTable.AddTermSheetButton.Text" />
      </DropDownToggle>
      <DropDownMenu>
        {Object.keys(TERM_SHEET_PRICING_TYPES).map((type) => (
          <DropDownItem key={type} onClick={() => handleAddTermSheet(selectedSquad?.id, type)}>
            <FormattedMessage
              id="TermSheets.LegacyTermSheetTable.AddTermSheetButton.OptionsText"
              values={{ type: TERM_SHEET_PRICING_TYPES[type] }}
            />
          </DropDownItem>
        ))}
      </DropDownMenu>
    </DropDown>
  );
};

export default AddLegacyTermSheetButton;
